'use client';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { Calendar, Rocket, Globe } from '@/public/images/icons/icons';
import { fadeInUp, viewportOnce } from '@/lib/animations';

export default function ForBanksPartners() {
  const t = useTranslations('Banks.Partners');

  const cards = [
    {
      id: 'launch',
      titleKey: 'card_1_title',
      descKey: 'card_1_desc',
      icon: <Rocket width={30} height={30} className="shrink-0"/>
    },
    {
      id: 'tips',
      titleKey: 'card_2_title',
      descKey: 'card_2_desc',
      icon: <Calendar width={30} height={30} className="shrink-0"/>
    },
    {
      id: 'european',
      titleKey: 'card_3_title',
      descKey: 'card_3_desc',
      icon: <Globe width={30} height={30} className="shrink-0"/>
    },
  ];

  return (
    <motion.section
      aria-labelledby="banks-partners-heading"
      className="w-full bg-white py-16 sm:py-24 px-6 sm:px-10 lg:px-16"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeInUp}
    >
      <div className="max-w-8xl mx-auto space-y-12">
        <div className="space-y-4">
          <span className="text-[10px] sm:text-xs font-semibold tracking-widest color-primary uppercase block">
            {t('badge')}
          </span>
          <h2 id="banks-partners-heading" className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-gray-900 w-full">
            {t.rich('heading', {
              highlight: (chunks) => <span className="color-primary">{chunks}</span>,
            })}
          </h2>
          <p className="text-sm sm:text-base text-gray-500 font-normal">
            {t('subheading')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div 
              key={card.id} 
              className="bg-white border border-gray-100/80 shadow-sm hover:shadow-md transition-shadow duration-200 rounded-3xl p-6 sm:p-8 flex items-start gap-5"
            >
              <div className="shrink-0 mt-0.5">
                {card.icon}
              </div>

              <div className="space-y-2.5">
                <h3 className="text-base sm:text-lg font-bold text-gray-900 leading-snug tracking-tight">
                  {t(card.titleKey)}
                </h3>
                <p className="text-xs sm:text-sm text-gray-500 leading-relaxed">
                  {t(card.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}